import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Landing from "./components/Landing";
import Result from "./components/Result";
import config from './config';

const theme = createTheme({
  typography: {
    fontFamily: [
      '"Open Sans"',
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  palette: {
    success: {
      main: '#27C24C',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FF8F2A',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#F84747',
      contrastText: '#FFFFFF',
    },
  }
});

export default function App() {
  const [page, setPage] = useState('LANDING'); // LANDING, RESULT
  const [website, setWebsite] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = (website, email, clientId, clientIP, submissionPage) => {
    dumpDataToSpreadSheet(email, website, clientId, clientIP, submissionPage);
    setEmail(email);
    setWebsite(website);
    setPage('RESULT');
  };

  const dumpDataToSpreadSheet = async (email, website, clientId, clientIP, submissionPage) => {
    await fetch(config.grader_data_dump_url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        website: website,
        clientId: clientId,
        clientIP: clientIP,
        submissionPage: submissionPage
      })
    });
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {page === 'LANDING' && <Landing handleSubmit={handleSubmit} />}
      {page === 'RESULT' && <Result email={email} website={website} />}
    </ThemeProvider>
  );
}
